import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

import FormTextarea from 'styled/Editor/FormTextarea';

const TextareaStyled = styled(FormTextarea)`
  width: 100%;
  min-width: auto;
  padding-left: 0;
  ${TYPOGRAPHY.name}
`;

export default TextareaStyled;
